import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { cn } from "@/ds/utils";
import { useInfiniteScroll } from "@/lib/common/useInfiniteScroll";
import type { PaginatedResponseModel, ProblemResponse } from "@/lib/http";
import type { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";
import { useRef, type RefObject } from "react";

export interface ListWithPreviewInfiniteScrollerProps<T> {
	forQuery: UseInfiniteQueryResult<InfiniteData<PaginatedResponseModel<T>>, ProblemResponse>;
	scrollRef?: RefObject<HTMLElement | null>;
}

export const ListWithPreviewInfiniteScroller = <T,>({ forQuery, scrollRef }: ListWithPreviewInfiniteScrollerProps<T>) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const showSpinner = useInfiniteScroll(ref, forQuery, scrollRef);

	return (
		<div ref={ref} className={cn("flex justify-center p-3", !showSpinner && "hidden")}>
			<Spinner />
		</div>
	);
};
